import state from '@/state'
import { hasFeatureFlagActive } from '@/engine/featureFlags/featureFlags.state'
import type { EnumRoles } from '@/utilities/user-roles'
import { PAID_PLANS, type EnumPlans } from '@/utilities/plans'

export const not = (item: boolean | (() => boolean)) => () => {
  return typeof item === 'boolean' ? !item : !item()
}

export const hasFeatureFlag = (flagName: string) => () => {
  return hasFeatureFlagActive(flagName)
}

export const or = (...items: Array<boolean | (() => boolean)>) => () => {
  return items.some(item => {
    if (typeof item === 'boolean') {
      return item
    }
    return item()
  })
}

export const and = (...items: Array<boolean | (() => boolean)>) => () => {
  return items.every(item => {
    if (typeof item === 'boolean') {
      return item
    }
    return item()
  })
}

export const hasPlan = (...plans: EnumPlans[]) => () => {
  const plan = state.organizations.getCurrentOrganization.plan.product_id
  return plans.includes(plan)
}

export const isPaidPlan = () => () => {
  const plan = state.organizations.getCurrentOrganization?.plan?.product_id
  return plan !== undefined && PAID_PLANS.includes(plan)
}

export const hasRole = (...roles: EnumRoles[]) => () => {
  const role = state.organizations.getCurrentOrganization.role.id

  return roles.includes(role)
}

export const isOwner = () => () => {
  return state.organizations.getCurrentOrganization.ownerEmail === state.user.userLogged.email
}

export const hasCountryPaymentsSupport = () => () => {
  return state.config.countriesWithPayments
    .map(country => country.code)
    .includes(state.organizations.getCurrentOrganization.countryCode)
}
